import { render, staticRenderFns } from "./CustomTab.vue?vue&type=template&id=97753f38"
import script from "./CustomTab.vue?vue&type=script&lang=js"
export * from "./CustomTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97753f38')) {
      api.createRecord('97753f38', component.options)
    } else {
      api.reload('97753f38', component.options)
    }
    module.hot.accept("./CustomTab.vue?vue&type=template&id=97753f38", function () {
      api.rerender('97753f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomTab.vue"
export default component.exports